module.exports = __webpack_public_path__ + "static/media/3_2.544b08e4.png";